module.exports = __webpack_public_path__ + "static/img/order_under@2x.03e16790.png";